// 如果 custom-review-with-product 尚未注册，则定义并注册该 WebComponent
if (!customElements.get("custom-review-with-product")) {
  class CustomReviewWithProduct extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.swiperEl = null;
      this.pagination = null;
      this.prevButton = null;
      this.nextButton = null;

      this.resizeTimer = null;
      this.handleResize = this.handleResize.bind(this);

      this._impressionObserver = null;
      this._impressionFired = false;
      this._onImpressionScroll = this._onImpressionScroll.bind(this);
      this._onProductBlockClick = this._onProductBlockClick.bind(this);
    }

    connectedCallback() {
      this.swiperEl = this.querySelector(".swiper");
      this.pagination = this.querySelector(".swiper-pagination");
      this.prevButton = this.querySelector(".swiper-button-prev");
      this.nextButton = this.querySelector(".swiper-button-next");

      if (this.swiperEl) {
        this.initSwiper();
      }

      window.addEventListener("resize", this.handleResize);
      this.initCommentsImpression();
      this.addEventListener("click", this._onProductBlockClick);
    }

    /** 埋点 */
    initCommentsImpression() {
      const wrap = this.querySelector(".custom-review-with-product-wrapper");
      if (!wrap) return;

      this._checkCommentsImpression();
      if (this._impressionFired) return;

      if ("IntersectionObserver" in window) {
        this._impressionObserver = new IntersectionObserver(
          () => {
            this._checkCommentsImpression();
          },
          { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] },
        );
        this._impressionObserver.observe(wrap);
      } else {
        window.addEventListener("scroll", this._onImpressionScroll, {
          passive: true,
        });
        window.addEventListener("resize", this._onImpressionScroll, {
          passive: true,
        });
      }
    }

    _onImpressionScroll() {
      this._checkCommentsImpression();
    }

    _checkCommentsImpression() {
      if (this._impressionFired) return;
      const wrap = this.querySelector(".custom-review-with-product-wrapper");
      if (!wrap) return;
      const r = wrap.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.bottom > vh || r.bottom < 0) return;

      this._impressionFired = true;
      this.teardownCommentsImpression();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "module_impression",
        event_parameters: {
          module: "comments",
        },
      });
    }

    teardownCommentsImpression() {
      if (this._impressionObserver) {
        this._impressionObserver.disconnect();
        this._impressionObserver = null;
      }
      window.removeEventListener("scroll", this._onImpressionScroll);
      window.removeEventListener("resize", this._onImpressionScroll);
    }

    /** 埋点 */
    _getDiscountFromProductLink(anchor) {
      const priceEl = anchor.querySelector(".price.active");
      if (!priceEl) return 0;
      const compareEl = priceEl.querySelector(".tag_sale-compare-price");
      const clone = priceEl.cloneNode(true);
      clone.querySelectorAll(".tag_sale-compare-price").forEach((n) => n.remove());
      const price =
        parseFloat((clone.textContent || "").replace(/[^\d.]/g, "")) || 0;
      const compare =
        parseFloat((compareEl?.textContent || "").replace(/[^\d.]/g, "")) || 0;
      return compare > price ? +(compare - price).toFixed(2) : 0;
    }

    _onProductBlockClick(e) {
      const anchor = e.target.closest(
        ".custom-review-with-product_block-info__product",
      );
      if (!anchor || !this.contains(anchor)) return;

      const raw = anchor.getAttribute("data-product-data");
      if (!raw) return;

      const product_item = raw.split("::");
      const sku = product_item[0];
      const itemListId = product_item[4];
      const itemListName = product_item[4];

      let item_name = "";
      let item_variant = "";
      let item_category = "";
      let item_category2 = "Standard";
      if (
        typeof product_handle_map !== "undefined" &&
        product_handle_map &&
        product_handle_map.has(sku)
      ) {
        item_name = product_handle_valueMap[sku][0];
        item_variant = product_handle_valueMap[sku][1];
        item_category = product_handle_valueMap[sku][2];
        item_category2 = product_handle_valueMap[sku][3];
      }

      const discount = this._getDiscountFromProductLink(anchor);
      const buttonName = "Comments product";

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "select_item",
        event_parameters: {
          item_list_id: itemListId,
          item_list_name: itemListName,
          button_name: buttonName,
          items: [
            {
              item_id: sku,
              item_name: item_name,
              discount: discount,
              index: product_item[2],
              item_list_id: itemListId,
              item_list_name: itemListName,
              item_category: item_category,
              item_category2: item_category2,
              item_category3: (product_item[6] || "").replace(
                "Default Title",
                "none",
              ),
              item_category4: product_item[7] || "",
              item_category5: product_item[5] || "",
              item_variant: item_variant,
              item_brand: "SHOKZ",
              price: Number(
                (product_item[9] || "0")
                  .split("$")
                  .join("")
                  .split(",")
                  .join("."),
              ),
              quantity: Number(product_item[10]) || 1,
              currency: "AUD",
            },
          ],
        },
      });
    }

    initSwiper() {
      // console.groupCollapsed("[评价轮播] 开始初始化");
      const width = this.swiperEl.offsetWidth;
      // const ratio = 448 / 1200;
      // const slideWidth = width * ratio;
      const slideWidth = width / 2.8;
      // console.log(
      //   "[评价轮播] 容器宽度：",
      //   width,
      //   "计算的卡片宽度：",
      //   slideWidth,
      // );

      this.swiper = new Swiper(this.swiperEl, {
        init: false,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        watchSlidesProgress: true,
        pagination: {
          el: this.pagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: {
          1000: {
            centeredSlides: false,
          },
        },
      });
      // console.log("[评价轮播] Swiper 实例已创建（未初始化）", this.swiper);

      // this.swiper.on("init", () => {
      //   console.log(
      //     "[评价轮播] 触发 init 事件，当前 activeIndex：",
      //     this.swiper.activeIndex,
      //     "realIndex：",
      //     this.swiper.realIndex,
      //   );
      // });

      // 设置 CSS 变量
      this.swiperEl.style.setProperty(
        "--custom-review-width",
        `${slideWidth}px`,
      );
      // console.log(
      //   "[评价轮播] 已设置 CSS 变量 --custom-review-width：",
      //   `${slideWidth}px`,
      // );
      this.swiper.init();
      // console.log("[评价轮播] 已手动执行 swiper.init()");

      requestAnimationFrame(() => {
        setTimeout(() => {
          this.swiper.update(true);
          this.swiperEl.classList.add("is-calculated");

          window.reviewSwiper = this.swiper;
          // console.log(
          //   "[评价轮播] 浏览器已完成真实渲染，已挂载 reviewSwiper 并激活缩放样式",
          // );
          // console.groupEnd();
        }, 500);
      });
    }

    handleResize() {
      if (!this.swiperEl || !this.swiper) return;

      // 先移除计算完成样式，避免过渡错乱
      this.swiperEl.classList.remove("is-calculated");

      // 防抖：避免 resize 高频触发
      clearTimeout(this.resizeTimer);

      // 重新计算宽度并赋值
      const width = this.swiperEl.offsetWidth;
      const slideWidth = width / 2.8;

      this.swiperEl.style.setProperty(
        "--custom-review-width",
        `${slideWidth}px`,
      );

      // 更新 Swiper

      // 500ms 后再加回 class，恢复缩放样式
      this.resizeTimer = setTimeout(() => {
        this.swiper.update(true);
        this.swiperEl.classList.add("is-calculated");
      }, 500);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      this.removeEventListener("click", this._onProductBlockClick);
      this.teardownCommentsImpression();
      this._impressionFired = false;

      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }

      if (this.swiper && typeof this.swiper.destroy === "function") {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("custom-review-with-product", CustomReviewWithProduct);
}
